module.exports = __webpack_public_path__ + "img/4.f03b426d.png";